<template>
    <div>
        <b-card>
            <targets 
                :tableName="targets.tableName"
                :columnData="targets.columnData"
            >
            </targets>

            <current-progress-overview 
                :tableName="currentProgressOverview.tableName"
                :tableHeader="currentProgressOverview.tableHeader"
                :tableHeaderData="currentProgressOverview.tableHeaderData"
                :columnData="currentProgressOverview.columnData"
                @onLoadTable="onLoadTable"
            >
            </current-progress-overview>

            <targets-and-current-progress-overview-charts-other-discipline-steelstructure
                v-if="showCharts"
                :rowData="rowData"
            >
            </targets-and-current-progress-overview-charts-other-discipline-steelstructure>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import Targets from '@/components/pages/project/percent_progress/common/tables/targets.vue';
import CurrentProgressOverview from '@/components/pages/project/percent_progress/common/tables/current_progress_overview.vue';
import TargetsAndCurrentProgressOverviewChartsOtherDisciplineSteelstructure from '@/components/pages/project/percent_progress/other_discipline/steelstructure/targets_and_current_progress_overview/targets_and_current_progress_overview_charts_other_discipline_steelstructure.vue';

export default {
    name: 'targets_and_current_progress_overview_other_discipline_steelstructure',
    components: {
        Targets,
        CurrentProgressOverview,
        TargetsAndCurrentProgressOverviewChartsOtherDisciplineSteelstructure,
    },
    data() {
        return {
            rowData: [],
            showCharts: false,
            //Targets table
            targets: {
                tableName: 'progress_other_discipline_steelstructure_targets',
                columnData: [
                    {
                        label: Vue.i18n.translate('table.step_no'),
                        field: 'step_no',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.date_of_progress_measurement'),
                        field: 'step_date',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.step_calendar'),
                        field: 'step_calendar',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.percent_progress_targets_work_value'),
                        field: 'percent_progress_targets_work_value',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.recovery_1_percent_progress_targets_work_value'),
                        field: 'recovery_1_percent_progress_targets_work_value',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.targets_value_works_from_total_estimated'),
                        field: 'targets_value_works_from_total_estimated',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.recovery_1_target_value_works_from_total_estimated'),
                        field: 'recovery_1_target_value_works_from_total_estimated',
                        numeric: false,
                        html: false,
                    },
                ],
            },
            //Current Progress Overview table
            currentProgressOverview: {
                tableName: 'progress_other_discipline_steelstructure_current_progress_overview',
                tableHeader: true,
                tableHeaderData: {
                    start: 4,
                    values: [
                        {
                            text: 'table.from_total_estimated',
                            colspan: 2,
                        },
                        {
                            text: 'table.from_total_current_available',
                            colspan: 2,
                        },
                        {
                            text: 'table.from_periodic_current_available_performed',
                            colspan: 2,
                        },
                    ]
                },
                columnData: [
                    {
                        label: Vue.i18n.translate('table.step_no'),
                        field: 'step_no',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.date_of_progress_measurement'),
                        field: 'step_date',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.step_calendar'),
                        field: 'step_calendar',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.ist_progress_total_work_value_calculation'),
                        field: 'ist_progress_total_work_value_calculation',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.ist_progress_total_work_value_status'),
                        field: 'ist_progress_total_work_value_status',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.percent_ist_progress_total_work_value_calculation'),
                        field: 'percent_ist_progress_total_work_value_calculation',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.percent_ist_progress_total_work_value_status'),
                        field: 'percent_ist_progress_total_work_value_status',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.percent_peformed_from_available_work_value_calculation'),
                        field: 'percent_peformed_from_available_work_value_calculation',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.percent_peformed_from_available_work_value_status'),
                        field: 'percent_peformed_from_available_work_value_status',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.percent_performed_value_calculation'),
                        field: 'percent_performed_value_calculation',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.percent_performed_value_status'),
                        field: 'percent_performed_value_status',
                        numeric: false,
                        html: false,
                    },
                ],
            }
        }
    },
    methods: {
        onLoadTable (response) {
            //Show charts after table is loaded
            this.rowData    = response.data;
            this.showCharts = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/other_discipline/steelstructure/targets_and_current_progress_overview/targets_and_current_progress_overview_other_discipline_steelstructure.vue